import React, { useEffect } from 'react';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { BI_CONSTANTS } from '../hooks/useBiLogger/biConstants';
import { DomainWrapper } from '../features/domain/DomainWrapper';

export function Domain() {
  const biLogger = useBiLogger();

  useEffect(() => {
    biLogger.pageView(BI_CONSTANTS.SCREENS.DOMAIN_PAGE);
  }, []);

  return <DomainWrapper />;
}
